import { Component } from '@angular/core';

@Component({
    selector: 'add-mapping',
    templateUrl: './add-mapping.component.html'
})
export class AddMappingComponent {

}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mappingfilters/addmapping/add-mapping.component.ts